.textLink {
  --ixf-text-link-color: var(--ixf-text-tone-md);

  cursor: pointer;
  position: relative;
  color: var(--ixf-text-link-color) !important;
  text-decoration: none;
  text-underline-offset: var(--ixf-space-1);
  text-decoration-thickness: 2px;
  text-decoration-color: var(--ixf-text-link-color) !important;
  transition: all 200ms ease;
  display: inline-flex;
  word-break: keep-all;
  overflow: hidden;
  margin: calc(-1 * var(--ixf-space-1));
  padding: var(--ixf-space-1);

  > * {
    color: var(--ixf-text-link-color);
  }

  &[disabled="true"] {
    cursor: default;
  }

  &.isFullWidth {
    width: 100%;
    display: block;
    text-align: center;
  }

  &.underline {
    &-never {
      text-decoration: none;
    }

    &-always {
      text-decoration: underline;
    }

    &-hover {
      &:hover,
      &:focus,
      &:active {
        opacity: 1;
        text-decoration: underline;
      }
    }
  }

  &::before {
    content: "";
    position: absolute;
    inset: calc(-1 * var(--ixf-space-1));
    border-radius: var(--ixf-border-radius-1);
    pointer-events: none;
    overflow: hidden;
    transform: translateZ(0);
  }

  &:hover,
  &:focus,
  &:active {
    opacity: 0.5;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    opacity: 1;

    &::before {
      box-shadow: var(--ixf-text-link-color) 0 0 0 2px;
    }
  }
}
